<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s40O5O/tc-custom/9781429990417.jpg?1728259194186" alt="This image is the cover for the book Stars and Gods"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stars and Gods
      </h1>
      <p class="bookDescription body article font2">
        <p>Larry Niven is the <i>New York Times</i> bestselling author of such classic science fiction novels as Ringworld and Destiny's Road. One of his previous collections, <i>N-Space</i>, was lauded by the <i>Houston Post</i> as "Outstanding . . . hours of entertainment," while <i>Publishers Weekly</i> called it "A must for science fiction fans." A follow-up volume, <i>Playgrounds of the Mind</i>, was praised by <i>Kirkus Reviews</i> as "Grand Entertainment."<br/><br/>Niven returns with the sequel to his most recent collection, <i>Scatterbrain</i>, which gathers an equally engaging assortment of Niven's latest work, all in one captivating volume. Here are choice excerpts from his most recent novels, including <i>Ringworld's Child</i>, as well as short stories, non-fiction, interviews, editorials, collaborations, and correspondence. <i>Stars and Gods </i>roams all over a wide variety of fascinating topics, from space stations to conventional etiquette.<br/><br/>Give yourself a treat, and feel free to pick the brain of one of modern science fiction's most fascinating thinkers.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Larry Niven
      </h2>
      
      <p class="authorDescription body article"><P><B>Larry Niven</B> is the award-winning author of the Ringworld series, along with many other science fiction masterpieces, and fantasy novels including the Magic Goes Away series. His <I>Beowulf's Children</I>, co-authored with Jerry Pournelle and Steven Barnes, was a <I>New York Times</I> bestseller. He has received the Nebula Award, five Hugos, four Locus Awards, two Ditmars, the Prometheus, and the Robert A. Heinlein Award, among other honors. He lives in Chatsworth, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e05af7da